export const config = {
    baseURL: window.__APP_CONFIG__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL ?? '',
    WEB_BASE_URL: window.__APP_CONFIG__?.REACT_APP_WEB_BASE_URL ?? process.env.REACT_APP_WEB_BASE_URL ?? '',
    AUTH_CLIENT_ID: window.__APP_CONFIG__?.REACT_APP_AUTH_CLIENT_ID ?? process.env.REACT_APP_AUTH_CLIENT_ID ?? '',
    AUTH_SCOPE: window.__APP_CONFIG__?.REACT_APP_AUTH_SCOPE ?? process.env.REACT_APP_AUTH_SCOPE ?? '',
    AUTHORITY: 'https://login.microsoftonline.com/common',
    AUTH_REDIRECT_URI: window.__APP_CONFIG__?.REACT_APP_AUTH_REDIRECT_URI ??
        process.env.REACT_APP_AUTH_REDIRECT_URI ??
        'http://localhost:3000/login',
    AUTH_LOGOUT_REDIRECT_URI: window.__APP_CONFIG__?.REACT_APP_AUTH_LOGOUT_REDIRECT_URI ??
        process.env.REACT_APP_AUTH_LOGOUT_REDIRECT_URI ??
        '/',
    PDOK_BASE_URL: window.__APP_CONFIG__?.REACT_APP_PDOK_BASE_URL ??
        process.env.REACT_APP_PDOK_BASE_URL ??
        ''
};
